<template>
       <v-list class="pa-0 card-list mt-5" v-if="deliveries.length > 0">
       <v-divider></v-divider>
        <template v-for="order in deliveries">
            <v-list-item :key="order._id" link @click="select(order)" :dark="isMine(order)" :class="{'primary': isMine(order)}">
                <v-list-item-avatar v-if="order._courier" color="primary">
                <v-img :src="order._courier.avatar" v-if="order._courier.avatar"></v-img>
                <span  class="white--text text-h5" v-else v-text="initials(order._courier.name)"></span>
                </v-list-item-avatar>
                <v-list-item-avatar v-else-if="order._host.logo">
                <v-img :src="order._host.logo"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                <v-list-item-title>#{{order.number}} {{ order._host.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ order._to.name }}</v-list-item-subtitle>
                <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                {{ order.due | moment('HH:mm') }} 
                <v-list-item-action-text>{{order.distance}} km</v-list-item-action-text>
                </v-list-item-action>
            </v-list-item>
            <v-card-actions v-if="isMine(order) && order.transfer && !order.done">
                      <v-btn  color="primary" target="_blank" :href="`https://www.google.com/maps/search/${order._to.name}`"><v-icon left>mdi-map-marker-outline</v-icon>
                      route</v-btn>
              <v-spacer></v-spacer>
              <v-btn  color="primary" @click.stop="setDone(order)">
              <v-icon left>check</v-icon>
              Afgeleverd</v-btn>
            </v-card-actions>
            <v-divider :key="'d' + order._id"></v-divider>
        </template>
        </v-list>
        <empty
           v-else
            icon="mdi-bike-fast"
            description="Er zijn geen bestellingen om op te halen"
        ></empty>
         
</template>

<script>
import empty from "@/components/empty";
import locationService from "@/modules/locationService";
import { mapActions, mapGetters } from "vuex";
import OrderTable from '../components/OrderTable.vue'
export default {
  props: ['showAll'],
   components: {empty, OrderTable},
   mixins: [locationService],
   data: () => ({
  }),
  computed: {
      ...mapGetters(['getDeliveries','user','orders']),
    deliveries:{
        get(){
            return this.getDeliveries.filter(d=>!d.done || this.showAll)
        },
        set(value){
            this.setDeliveries(value)
        }
    },
  },
  mounted(){
      this.load()
  },
  methods: {
        ...mapActions(['setDeliveries']),
    async load() {
      let self = this
      this.$events.$off('courier_modified')
      this.$events.$off('courier_added')
      this.$events.$off('courier_removed')
      this.$events.$on('courier_modified',self.updateOrder)
      this.$events.$on('courier_added',self.updateOrder)
      this.$events.$on('courier_removed',self.updateOrder)
      //if (this.orders && this.orders.length>0) return false
      let response = await this.$http.get("/api/order/deliveries");
      this.deliveries = response.data.map(d=>{
        d.distance = this.getDistance(this.address,d._to)
        return d
      });
    },
    removeOrder(item){
      this.deliveries = this.deliveries.filter(d=>d._id !== item._id)
    },
    async updateOrder(item){
      this.removeOrder(item)
      let response = await this.$http.get("/api/order/deliveries/" + item.id);
      let order = response.data[0]
      if (order) {
        order.distance = this.getDistance(this.address,order._to)
        this.deliveries = this.deliveries.filter(d=>d._id!=order._id)
        this.deliveries.push(order)
      }
    },
    isMine(order){
      return order._courier && order._courier._id==this.user._id && order.transfer ? true : false
    },
    async select(order){
      if (order._courier) return false
      if (
      await this.$root.$confirm(
        "Order ophalen?",
        "Weet je zeker dat je deze order ophaalt en bezorgt bij de besteller?",
        { yes: "Ja", cancel: "Nee" }
      )
    ) {
       let response = await this.$http.post(
          "/api/edge/DELIVERS/" + order._id,
          { _id: this.user._id, date: new Date() }
        );
        //order._courier = {_id: this.user._id,name: this.user.name,avatar: this.user.avatar }
        await this.$http.put('/api/' + order._id, {updated: new Date()})
    } else {
      
    }
    },
    async setDone(order){
        await this.$http.put('/api/' + order._id, {done: new Date(), updated: new Date()})
    },
    initials(item) {
      var name = item.name;
      if (!name) name = "NOT";
      var initials = name.match(/\b\w/g) || [];
      return ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
    },
  }
}
</script>